var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pages > 1)?_c('ul',{staticClass:"pagination"},_vm._l((_vm.pagesArray),function(page){return _c('li',{key:page.page,staticClass:"page",class:{
                  active: page.page === _vm.currentPage,
                  'separator-before': page.separator === 'before',
                  'separator-after': page.separator === 'after',
              },on:{"click":function($event){return _vm.$emit('setPage',page.page)}}},[_vm._v("\n    "+_vm._s(page.label)+"\n  ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }